import { render, staticRenderFns } from "./AIAssistantMessage.vue?vue&type=template&id=334e859a&scoped=true"
import script from "./AIAssistantMessage.vue?vue&type=script&lang=js"
export * from "./AIAssistantMessage.vue?vue&type=script&lang=js"
import style0 from "./AIAssistantMessage.vue?vue&type=style&index=0&id=334e859a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e859a",
  null
  
)

export default component.exports